import {Component, Input, OnInit, EventEmitter, Output} from '@angular/core'
import {NgbModal} from '@ng-bootstrap/ng-bootstrap'
import {ModalProgramDescTablaComponent} from '../modal-program-desc-tabla/modal-program-desc-tabla.component'

@Component({
  selector: 'dmmp-search-programs-desc-tabla',
  templateUrl: './search-programs-desc-tabla.component.html'
})
export class SearchProgramsDescTablaComponent implements OnInit {
  @Input() identifier
  @Input() data
  @Input() filterPrograms
  @Input() categories = []
  @Input() textNoFound = 'No se encontraron resultados'
  @Input() textAll = 'Todos'
  @Output() categoryOut = new EventEmitter()
  @Output() categoriesOut = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  status = true
  notEmptyPost = true
  statusInit = 8
  searchModel

  constructor(private modalService: NgbModal) {
  }

  ngOnInit() {
  }

  click(category) {
    this.categoryOut.emit(category)
  }

  sendData(data, identifier) {
    this.status = false
    const modalRef = this.modalService.open(ModalProgramDescTablaComponent, {size: 'lg'})
    modalRef.componentInstance.data = data
    modalRef.componentInstance.identifier = identifier
    modalRef.componentInstance.categoriesOut.subscribe(($e) => {
      this.categoriesOut.emit($e)
    })
    modalRef.componentInstance.anchorCustom.subscribe(($e) => {
      this.anchorCustom.emit($e)
    })
  }

  onScroll() {
    if (this.notEmptyPost) {
      this.statusInit += 8
    }
  }
}
